import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getSalaPorId } from 'services/servicioGet';
import { Sala } from 'utils/models/types';

interface SalaPorIdState {
  sala: {};
  loadingSala: boolean;
  errorSala: string | null;
}

// Estado inicial del slice
const initialState: SalaPorIdState = {
  sala: '',
  loadingSala: false,
  errorSala: null,
};

export const fetchSalaPorId = createAsyncThunk<
  Sala,
  number, // Id de la sala
  { rejectValue: string }
>('salas/fetchSalaPorId', async (id, thunkAPI) => {
  try {
    const response = await getSalaPorId(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar la sala');
  }
});

// Slice de sala por id
const salaSlice = createSlice({
  name: 'sala',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSalaPorId.pending, state => {
        state.loadingSala = true;
        state.errorSala = null;
      })
      .addCase(fetchSalaPorId.fulfilled, (state, action) => {
        state.sala = action.payload;
        state.loadingSala = false;
      })
      .addCase(fetchSalaPorId.rejected, (state, action) => {
        state.loadingSala = false;
        // Capturamos el mensaje de error retornado por rejectWithValue
        state.errorSala = action.payload as string;
      });
  },
});

export default salaSlice.reducer;
